module.exports = __webpack_public_path__ + "img/hr-green-pita-mini-13.e56d6b1e.png";